import axios from 'axios';
import { SmallCard } from '../Cards/SmallCard';
import { LargeCard } from '../Cards/LargeCard';
import {
  get,
  post,
  put,
  deleteRequestV2,
} from '../../api/usersModule/httpClient';
import { useEffect, useState } from 'react';
import { CDBModal } from 'cdbreact';
import { ModalProjects } from '../Modals/ModalProjects';
import swal from 'sweetalert';
import { useDebounce } from '../../hooks/useDebounce';
import Swal from 'sweetalert2';

const usersheaders = ['Código Proveedor', 'Nombre', 'Ciudad', 'Dirección', 'Celular', 'Descripción', 'Fecha de modificación' , 'Usuario'];
const defaultFormData = {
  Nit: '',
  ProjectName: '',
  City: '',
  ProviderAddress: '',
  Phone: '',
  ProjectDescription: '',
  CreateDate: '',
  ModificationDate: '',
  User: '',
};
const PoolID = 'us-east-1_Z3h6lkdFJ';
const ClientID = '771qni77qtkgjbjiebjuqfnij9';

export const CrudSuppliers = ({ userName, permissions, project, setChange, change}) => {
  const [data, setData] = useState([]);
  const [state, setState] = useState({ modal6: false });
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [pressedButton, setPressedButton] = useState('');
  const [action, setAction] = useState('');
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 500);
  const [initialRender, setInitialRender] = useState(true);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [changePage, setChangePage] = useState(false);

  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  const getData = async (search, nit, statusPage) => {
    try {
      setLoading(true);
      const response = await get(`/projects?page=${statusPage}&search=${search}&Nit=${nit}&limit=${itemsPerPage}`);

      setData(response.items);
      setTotalItems(response.answer ? response.pagination.totalItems : 0);
  
    } catch (error) {
      swal('Error', 'Ocurrio un error al obtener los datos ', 'error');
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    if (!changePage) {
      getData(debouncedSearch, project, page);
    }else {
      setChangePage(false)
    }
  }, [page, initialRender]);

  useEffect(() => {
    getData(debouncedSearch, project, 1);
    setChangePage(true);
    setPage(1)
  }, [debouncedSearch]);

  useEffect(() => {
    getData(debouncedSearch, project, 1);
    setChangePage(true);
    setPage(1)
  }, [itemsPerPage]);

  const getProject = async (nit) => {
    const data = await get(`/projects?Nit=${nit}`);

    const [ciudad, departamento] = data.items[0].City.split(',');
    const [indicativo, celular] = data.items[0].Phone.split('-');

    setFormData({
      Nit: data.items[0].Nit,
      ProjectName: data.items[0].ProjectName,
      Department: departamento,
      City: ciudad,
      ProviderAddress: data.items[0].ProviderAddress,
      CountryCode: indicativo,
      Phone: celular,
      ProjectDescription: data.items[0].ProjectDescription,
      user: userName,
    });

    toggle(6)();
  };

  const convertDataToArray = () => {
    try {
      return data.map((item) => [
        item.Nit.toUpperCase(),
        item.ProjectName.toUpperCase(),
        item.City.split(',')[0],
        item.ProviderAddress.toUpperCase(),
        item.Phone,
        item.ProjectDescription.charAt(0).toUpperCase() + item.ProjectDescription.slice(1).toLowerCase(),
        item.ModificationDate,
        item.User.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
      ]);
    } catch (error) {
      console.error(error);
      return [];
    }
  };  

  const toggle = (nr) => () => {
    let modalNumber = 'modal' + nr;
    setState({
      ...state,
      [modalNumber]: !state[modalNumber],
    });
  };

  const handleChange = (targets) => {
    targets.forEach((target) => {
      const { id, value } = target;
      setFormData((prevData) => ({ ...prevData, [id]: value }));
    });
  };

  const handleSubmit = () => {
    let success = false;

    if(
      formData.Nit === '' ||
      formData.ProjectName === '' ||
      formData.City === '' ||
      formData.ProviderAddress === '' ||
      formData.Phone === ''
    ){
      swal('Error', 'Por favor, rellene todos los campos', 'error');
      setLoading(false);
    } else {
      if (!/^[a-zA-Z\d]{9,}$/.test(formData.Nit)) {
        setLoading(false);
        swal(
          'Error',
          'El Código de proveedor no es válido, debe tener al menos 9 caracteres (letras o números).',
          'error'
        );
      }else{
        const regex = /^([+]{1})([0-9]{1,3})([0-9]{10})/i;
        if (!regex.test(formData.CountryCode + formData.Phone)) {
          setLoading(false);
          swal(
            'Error',
            'El número de teléfono no es válido, debe tener la forma +57xxxxxxxxxx',
            'error'
          );
        }else{
          success = true;
        }
      }
    }

    return success;
  };

  const saveData = async () => {
    Swal.fire({
      title: `${action === "create" ? 'Creando' : 'Actualizando'} Proveedor`,
      text: 'Por favor, espere...',
      icon: 'info',
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });
    if (action === 'create') {
      const info = {
        Nit: formData.Nit.toUpperCase(),
        ProjectName: formData.ProjectName.charAt(0).toUpperCase() + formData.ProjectName.slice(1),
        City: formData.City + "," + formData.Department,
        ProviderAddress: formData.ProviderAddress.toUpperCase(),
        Phone: formData.CountryCode + "-" + formData.Phone,
        ProjectDescription: formData.ProjectDescription.toUpperCase(),
        user: userName ? userName.charAt(0).toUpperCase() + userName.slice(1) : 'Admin',
        clientid: ClientID,
        userpool: PoolID,
      };
      try {
        const response = await post('/projects', info, null, true);
        Swal.close();
        
        if (response && response.answer === true) {
          swal(
            'Proveedor creado',
            'El proveedor se creo correctamente',
            'success'
          );
          setChange(change + 1);
          getData('', project, 1);
        } else {
          swal(
            'Error',
            response?.error || 'Error al crear el proveedor verifique que no exista uno con el mismo código',
            'error'
          );
        }
      } catch (error) {
        Swal.close();
        swal(
          'Error',
          'Ha ocurrido un error al crear el proveedor',
          'error'
        );
        console.error(error);
      }
    } else {
      setFormData({ ...formData, user: 'Admin' });
      const info = {
        Nit: formData.Nit.toUpperCase(),
        ProjectName: formData.ProjectName.charAt(0).toUpperCase() + formData.ProjectName.slice(1),
        City: formData.City + "," + formData.Department,
        ProviderAddress: formData.ProviderAddress.toUpperCase(),
        Phone: formData.CountryCode + "-" + formData.Phone,
        ProjectDescription: formData.ProjectDescription.toUpperCase(),
        user: userName ? userName.charAt(0).toUpperCase() + userName.slice(1) : 'Admin',
        clientid: ClientID,
        userpool: PoolID,
      };
      try {
        const response = await put('/projects', info, null, true);
        Swal.close();
        
        if (response && response.answer === true) {
          swal(
            'Proveedor Actualizado',
            'El proveedor se a actualizado correctamente',
            'success'
          );
          setChange(change + 1);
          getData('', project, 1);
        } else {
          swal(
            'Error',
            response?.error || 'Error al actualizar el proveedor',
            'error'
          );
        }
      } catch (error) {
        Swal.close();
        swal(
          'Error',
          'Ha ocurrido un error al actualizar el proveedor',
          'error'
        );
        console.error(error);
      }
    }
  };  

  const deleteProject = async () => {

    const body = {
        Nit: formData.Nit,
    };

    const confirmDelete = await Swal.fire({
        title: 'Confirmar Eliminación del Proveedor',
        text: 'Esta acción eliminará de manera permanente el Proveedor seleccionado, así como cualquier dato relacionado. ¿Está seguro de que desea proceder?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#146284',
        cancelButtonColor: '#EF4444',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
    });

    if (confirmDelete.isConfirmed) {

        Swal.fire({
            title: 'Eliminando Proveedor',
            text: 'Por favor, espere...',
            icon: 'info',
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            },
        });

        try {
            const response = await deleteRequestV2('projects', body, false);
            
            Swal.close();

            if (response && response.answer === true) {
                swal(
                    'Éxito',
                    'El proveedor se ha eliminado correctamente',
                    'success'
                );
                setChange(change + 1);
                toggle(6)();
                getData('', project, 1);
            } else {
                swal(
                    'Error',
                    response?.error || 'Error al eliminar el proveedor',
                    'error'
                );
            }
        } catch (error) {
            Swal.close();
            swal(
                'Error',
                'Ha ocurrido un error al eliminar el proveedor',
                'error'
            );
            console.error(error);
        }
    }
  };

  useEffect(() => {
    switch (pressedButton.split(',')[0]) {
      case 'create':
        if (permissions['Crear']) {
          setAction('create');
          setFormData(defaultFormData);
          toggle(6)();
        } else {
          swal({
            title: 'Error',
            text: 'No tiene permisos para crear proveedores',
            icon: 'error',
            buttons: ['', 'Aceptar'],
          });
        }
        break;
      case 'edit':
        if (permissions['Editar']) {
          setAction('edit');
          getProject(pressedButton.split(',')[1]);
        } else {
          swal({
            title: 'Error',
            text: 'No tiene permisos para editar proveedores',
            icon: 'error',
            buttons: ['', 'Aceptar'],
          });
        }
        break;
      case 'delete':
        if (permissions['Eliminar']) {
          deleteProject();
        } else {
          swal({
            title: 'Error',
            text: 'No tiene permisos para borrar proveedores',
            icon: 'error',
            buttons: ['', 'Aceptar'],
          });
        }
        break;
      case 'refresh':
        setData(['']);
        getData('', project, page);
        break;
      case 'closeModal':
        toggle(6)();
        break;
      case 'submitModal':
        const success = handleSubmit();
        if (success) {
          saveData();
          toggle(6)();
        }
        break;
      default:
        break;
    }
    setPressedButton('');
  }, [pressedButton]);

  return (
    <>
      <LargeCard
        name='Proveedores'
        headers={usersheaders}
        loading={loading}
        data={convertDataToArray()}
        totalItems={totalItems}
        setPage={setPage}
        page={page}
        setChangePage={setChangePage}
        setPressedButton={setPressedButton}
        setSearch={setSearch}
        cState={true}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />

      <CDBModal isOpen={state.modal6} toggle={toggle(6)}>
        <ModalProjects
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          handleChange={handleChange}
        />
      </CDBModal>
    </>
  );
};